const labelList = [
  {id: 311, name: 'Crema', alias: 'crema', color: '#dc3545'},
  {id: 312, name: 'Personal', alias: 'personal', color: '#0d6efd'},
  {id: 313, name: 'Work', alias: 'work', color: '#198754'},
];
export default labelList;
